define('responsive-gameday/controllers/LineupViewController',['require','exports','module','Responsive/controllers/ScrollViewController','../views/render/LineupViewRender','Responsive/util/renderComplete','GameDayCore','GameDayCore/GDModel/enums/events/EventTypes','GameDayCore/GDModel/enums/datasources/Datasources','gameday-resource-path/gameday-resource-path','jquery'],function(require,exports,module){
	var ScrollViewController = require( 'Responsive/controllers/ScrollViewController' ),
		LineupViewRender = require( '../views/render/LineupViewRender' ),
		renderComplete = require( 'Responsive/util/renderComplete' ),
		GameDayCore = require('GameDayCore'),
		EventEnums = require( 'GameDayCore/GDModel/enums/events/EventTypes' ),
		DatasourcesEnums = require( 'GameDayCore/GDModel/enums/datasources/Datasources' ),
		resourcePath = require("gameday-resource-path/gameday-resource-path"),
		$ = require('jquery');

	// Add private variables here
	var Superclass,
		templates,
		mainRender,
		pitcherStatsType = "pitcher",
		player_thumb_path = "http://mlb.mlb.com/images/gameday/mugshots/",
		ensureSeason = function (type, season, current) {
			return type === "R" || type !== "R" && season && season.season === current ? season : null;
		};

	// Add private methods here

	// Constructor
	function LineupViewController() {
		// Call super constructor
		LineupViewController.superclass.constructor.call(this);
		this.viewRender = new LineupViewRender();
		this.requiredData = {};
		this.active = 0;
		this.defaultSwitch = true;
	}

	// Prototype Inheritence
	ScrollViewController.spawn(LineupViewController).define({
		loadView: function () {
			var that = this;
			this.defaultSwitch = true;
			Superclass.loadView.call(this);
			this.content = null;
			$(this.getView()).on('click', 'nav.secondary li[data-view]', function (e) {
				var el = this;
				Array.prototype.forEach.call(
					document.querySelectorAll('nav.secondary li'),
					function(el) {
						el.removeAttribute('class');
					}
				);
				el.className = "active";
				e.preventDefault();
				e.stopPropagation();
				that.content.setAttribute('data-view', that.active = el.getAttribute('data-view'));
				that.setScroll();
				that.defaultSwitch = false;
			});
		},
		draw: function () {
			LineupViewController.superclass.draw.call(this);

			this.setClassName("LineupViewController");
		},

		viewWillAppear: function () {
			var that = this;

			Superclass.viewWillAppear.call(this);
				gdpath = linescore.gdid;
			this.onBeat = function (beatData) {
				// Request lineup data, then get gamecenter data for probables, then draw!
				// GameDayCore.addListener(GameDayCore.requestGameData(DatasourcesEnums.LINEUP,{
				// 	gdpath : gdpath
				// }), function(payload, evt) {
				// 	GameDayCore.removeListener(evt.type, this);
				// 	GameDayCore.addListener(GameDayCore.requestGameData(DatasourcesEnums.GAMECENTER), function(payload, evt) {
				// 		GameDayCore.removeListener(evt.type, this);
				// 		that.drawLineup();
				// 	})
				// });
			}

			GameDayCore.addListener(EventEnums.UPDATE, this.onBeat);
			that.showOverlay()
			this.onBeat();
		},

		viewWillDisappear: function () {
			var that = this;
			if (this.onBeat) {
				GameDayCore.removeListener(EventEnums.UPDATE, this.onBeat);
			}
		},

		drawLineup: function () {
			var data = GameDayCore.getGameData('players,lineup,game,gamecenter');
				that = this,
				data,
				playerMap = data.players && data.players.playerMap || {},
				lineupData = data.lineup ? $.extend({},data.lineup) : {
					home : { players : []},
					away : { players : []}
				};

			lineupData.teams = [];

			lineupData.home.index = 1;
			lineupData.home.label = 'home';
			lineupData.home.name = data.game.home.name_brief;
			lineupData.home.record = data.game.home.w + " - " + data.game.home.l;
			lineupData.away.index = 0;
			lineupData.away.label = 'away';
			lineupData.away.name = data.game.away.name_brief;
			lineupData.away.record = data.game.away.w + " - " + data.game.away.l;

			lineupData.active = that.active;
			lineupData.teams[lineupData.home.index] = lineupData.home;
			lineupData.teams[lineupData.away.index] = lineupData.away;
			lineupData.teams[lineupData.home.index].pitcher = data.gamecenter.home_probables;
			lineupData.teams[lineupData.away.index].pitcher = data.gamecenter.away_probables;
			lineupData.teams[lineupData.home.index].pitcher.mugshot = resourcePath.get('mugshot',{ pid : data.gamecenter.home_probables.player_id});
			lineupData.teams[lineupData.away.index].pitcher.mugshot = resourcePath.get('mugshot',{ pid : data.gamecenter.away_probables.player_id});

			lineupData.hasLineups = lineupData.home.players.length;

			lineupData.avg = function() {
				return playerMap[this.playerid].avg;
			};

			lineupData.rl = function() {
				return playerMap[this.playerid].rl;
			};

			lineupData.hr = function() {
				return playerMap[this.playerid].hr;
			};

			lineupData.rbi = function() {
				return playerMap[this.playerid].rbi;
			};

			this.childWrapper.innerHTML = this.viewRender.render(lineupData);
			renderComplete(function () {
				that.content = that.getView().querySelector('.lineup_container');
				that.setScroll();
				that.hideOverlay();
			});
		}
	});

	// Add view controller class to Gameday UI library
	Superclass = LineupViewController.superclass;
	return LineupViewController;
});
